























































import { Route } from 'vue-router'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { filterQueryParams } from '@/utils'
import { TabSettingName, Tabs } from '@/constants/appSettings'

@Component({
  components: {
    ControlTable: () => import('@/components/ControlTable.vue'),
    Paginate: () => import('@/components/Paginate.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class ManageArchivedData extends Vue {
  @Prop(Number) readonly page!: number | undefined
  @Prop(String) readonly query!: string

  $store!: ExStore
  searchKeyword!: string
  pending = true

  get patientIds() {
    return this.$store.getters['patient/sort']
  }

  get patients() {
    return this.$store.getters['patient/patients']
  }

  get totalCount() {
    return this.$store.getters['patient/totalCount'] || 0
  }

  get patientCount() {
    return Object.keys(this.patients || {}).length
  }

  get paginateQueryParams() {
    return filterQueryParams({ query: this.query })
  }

  get hasMultiplePages() {
    return this.totalCount > this.patientCount
  }

  get tabSettings() {
    return this.$store.getters['appSettings/displayTabs']
  }

  getWorkers(ids: number[]) {
    return this.$store.getters['worker/workersById'](ids || [])
  }

  handleKeywordSearch() {
    this.$router.push({
      name: 'ManageArchivedData',
      query: filterQueryParams({
        page: String(this.page || ''),
        query: this.searchKeyword
      })
    })
  }

  handleClickPatientId(patientId: number) {
    const params = { patientId: String(patientId) }
    this.$router.push({
      name:
        Tabs[
          this.tabSettings.filter(tab => tab.isActive)[0].name as TabSettingName
        ].routeName,
      params
    })
  }

  loadPatients(page: number, query?: string) {
    this.pending = true
    return this.$store
      .dispatch('patient/updateList', { page, query, archived: true })
      .then(() => {
        this.pending = false
        this.$store.dispatch('worker/updateList', {
          patientIds: this.patientIds
        })
      })
  }

  created() {
    const page = this.page || 1
    const query = this.query
    this.searchKeyword = query
    this.$store.commit('patient/clear')
    this.loadPatients(page, query)
  }

  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    const page = Number(to.query.page || 1)
    const query = typeof to.query.query === 'string' ? to.query.query : ''
    this.loadPatients(page, query)
    next()
  }
}
